/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../models/account';
import '../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveAccountRequest": {
                "fields": {
                  "accountId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveAccountResponse": {
                "fields": {
                  "account": {
                    "type": ".squareup.sfs.models.Account",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.service?.nested?.RetrieveAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.service?.nested?.RetrieveAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveAccountRequest @ squareup/sfs/services/account/retrieve_account.proto at 9:1
 */
export const RetrieveAccountRequest = $root.lookupType('squareup.sfs.service.RetrieveAccountRequest');
fixType(RetrieveAccountRequest, {
  accountId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveAccountRequest);
/**
 * SOURCE RetrieveAccountResponse @ squareup/sfs/services/account/retrieve_account.proto at 18:1
 */
export const RetrieveAccountResponse = $root.lookupType('squareup.sfs.service.RetrieveAccountResponse');
fixType(RetrieveAccountResponse);
Builder.createAndAttachToType(RetrieveAccountResponse);